module.exports = __webpack_public_path__ + "static/media/wizualizacja-92.fafa7698.png";